export default "__VITE_ASSET__BtS9Oj4z__"